const THUMBS_UP = '1f44d';
const CLAP = '1f44f';
const TADA = '1f389';
export const defaultEmojis: string[] = [THUMBS_UP, CLAP, TADA];

// Teamoji ids (atlassian-<name>) for the footer empty-state quick-react row — same 5 reactions as
// before (heart, thumbs up, fire, clap, raising hands), Teamoji-styled. Distinct from the 3-emoji
// `defaultEmojis` set and the 6-emoji set used elsewhere.
const TEAMOJI_RED_HEART = 'atlassian-red_heart';
const TEAMOJI_THUMBS_UP = 'atlassian-thumbs_up';
const TEAMOJI_FIRE = 'atlassian-fire';
const TEAMOJI_CLAP = 'atlassian-clap';
const TEAMOJI_RAISING_HANDS = 'atlassian-raising_hands';
export const footerReactionsDefaultEmojis: string[] = [
	TEAMOJI_RED_HEART,
	TEAMOJI_THUMBS_UP,
	TEAMOJI_FIRE,
	TEAMOJI_CLAP,
	TEAMOJI_RAISING_HANDS,
];
